import { Controller } from '@hotwired/stimulus'

export default class extends Controller {
  static values = {
    realEstateAdminId: String,
    rotationResource: { type: String, default: 'lead_assignment_rotations' },
  }

  static targets = ['arrowButton']

  moveUp(event) {
    const button = event.currentTarget
    const rotationId = button.dataset.rotationId
    this.moveRotation(rotationId, 'up', button)
  }

  moveDown(event) {
    const button = event.currentTarget
    const rotationId = button.dataset.rotationId
    this.moveRotation(rotationId, 'down', button)
  }

  moveRotation(rotationId, direction, button) {
    const csrfToken = document.querySelector('meta[name="csrf-token"]')?.getAttribute('content')

    // Disable all arrow buttons
    this.disableAllButtons()

    // Show loading state on clicked button
    const icon = button.querySelector('svg')
    const spinner = button.querySelector('.loading')
    if (icon) icon.classList.add('hidden')
    if (spinner) spinner.classList.remove('hidden')

    fetch(`/real_estate_admin/${this.realEstateAdminIdValue}/${this.rotationResourceValue}/${rotationId}/move_${direction}`, {
      method: 'PATCH',
      headers: {
        'Content-Type': 'application/json',
        'X-CSRF-Token': csrfToken,
        Accept: 'application/json',
      },
    })
      .then((response) => response.json())
      .then((data) => {
        if (data.status === 'success') {
          // Preserve current tab in URL hash before reload
          window.location.reload()
        } else {
          this.resetButton(button, icon, spinner)
          this.enableAllButtons()
          this.showFlashMessage(data.message || 'Erro ao mover roleta.', 'error')
        }
      })
      .catch((error) => {
        console.error('Error moving rotation:', error)
        this.resetButton(button, icon, spinner)
        this.enableAllButtons()
        this.showFlashMessage('Erro ao mover roleta.', 'error')
      })
  }

  disableAllButtons() {
    this.arrowButtonTargets.forEach((btn) => {
      btn.disabled = true
      btn.classList.add('opacity-50')
    })
  }

  enableAllButtons() {
    this.arrowButtonTargets.forEach((btn) => {
      btn.disabled = false
      btn.classList.remove('opacity-50')
    })
  }

  resetButton(button, icon, spinner) {
    if (icon) icon.classList.remove('hidden')
    if (spinner) spinner.classList.add('hidden')
  }

  showFlashMessage(message, type) {
    window.showNotification(message, type)
  }
}
